module.exports = __webpack_public_path__ + "static/media/normal.f4c3bc3a.svg";